import {
  cleanEnv,
  str,
  url,
} from 'envalid';

export const env = cleanEnv({
  REACT_APP_CLERK_PUBLISHABLE_KEY: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,
  REACT_APP_CLERK_SIGN_IN_URL: process.env.REACT_APP_CLERK_SIGN_IN_URL,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_SHA: process.env.REACT_APP_SHA,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
}, {
  REACT_APP_SHA: str({}),
  REACT_APP_VERSION: str({}),
  REACT_APP_CLERK_PUBLISHABLE_KEY: str({}),
  REACT_APP_CLERK_SIGN_IN_URL: url({}),
  REACT_APP_ENV: str<'local' | 'preview' | 'prod'>({}),
});

export const isProduction = env.REACT_APP_ENV === 'prod';

console.log('ENV', {
  REACT_APP_ENV: env.REACT_APP_ENV,
  REACT_APP_SHA: env.REACT_APP_SHA,
  REACT_APP_VERSION: env.REACT_APP_VERSION,
  REACT_APP_CLERK_PUBLISHABLE_KEY: env.REACT_APP_CLERK_PUBLISHABLE_KEY,
  REACT_APP_CLERK_SIGN_IN_URL: env.REACT_APP_CLERK_SIGN_IN_URL,
});
